export const notificationConstants = {
    GET_NOTIFICATIONS_BY_LOAN_OFFICER: "GET_NOTIFICATIONS_BY_LOAN_OFFICER",
    GET_NOTIFICATIONS_BY_MART_OFFICER: "GET_NOTIFICATIONS_BY_MART_OFFICER",
    DELETE_NOTIFICATIONS: "DELETE_NOTIFICATIONS",
    LOADING: "LOADING",
    RESPONSE_STATE: "RESPONSE_STATE"
}